import React from 'react';

import styled from '@emotion/styled';

import { tableFormatDateTimeNG } from '../../../utils/utils';
import TableMoreOptions from '../TableComponent/TableMoreOptions';

interface ViewBADriverInfoCellProps {
  data?: any;
  moreOptionsComponents?: React.ReactNode[];
}

const ViewBADriverInfoCell: React.FC<ViewBADriverInfoCellProps> = ({
  data,
  moreOptionsComponents,
}) => {
  return (
    <Container>
      <FirstRow>
        <div>BA Name: {data?.userName}</div>
        {moreOptionsComponents && (
          <TableMoreOptions
            moreOptionsComponents={moreOptionsComponents}
            data={data}
          />
        )}
      </FirstRow>

      <Divider></Divider>

      {/* <Row>
        <BoldText>Username:</BoldText> {data?.userName}
      </Row> */}
      <Row>
        <BoldText>Driver Name:</BoldText> {data?.lastName} {data?.firstName}
      </Row>
      <Row>
        <BoldText>Phone No:</BoldText> {data?.phoneNumber}
      </Row>
      <Row>
        <BoldText>No of Vehicles Operated:</BoldText>{' '}
        {data?.fleetTypes?.length || 0}
      </Row>
      <Row>
        <BoldText>Date Uploaded:</BoldText>{' '}
        {tableFormatDateTimeNG(data?.dateUploaded)}
      </Row>
    </Container>
  );
};

export default ViewBADriverInfoCell;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border-radius: 5px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  margin-bottom: 12px;
  font-size: 14px;
`;

const FirstRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};
  display: flex;
  position: relative;
`;

const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.palette.borderColor};
`;

const Row = styled.div`
  /* font-size: 14px; */
`;

const BoldText = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;
